module.exports = __webpack_public_path__ + "media/img/img-bg-mision-aa163e73.png";